export default "__VITE_ASSET__DUy6wrbh__"